import { Component } from '@angular/core';

@Component({
  selector: 'app-sonnet-three-seven',
  templateUrl: './sonnet-three-seven.component.html',
  styleUrls: ['./sonnet-three-seven.component.scss']
})
export class SonnetThreeSevenComponent {

}
